import { render, staticRenderFns } from "./Offer.vue?vue&type=template&id=7b12aa04&scoped=true"
import script from "./Offer.vue?vue&type=script&lang=ts"
export * from "./Offer.vue?vue&type=script&lang=ts"
import style0 from "./Offer.vue?vue&type=style&index=0&id=7b12aa04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b12aa04",
  null
  
)

export default component.exports